// ── company-detail-helpers: pure id-guard + label helpers (no JSX) ─────────
// Wave 1 (Companies). The company id is a STRING (bigint-safe) — passed VERBATIM
// to the typed client, NEVER Number()'d. A non-empty len<=200 string is the only
// client guard a real company id can take (mirrors the server's id parsing); a
// bad/absent id can't be a real record, so the detail page sends it back to the
// list rather than firing a doomed read.

export function isValidCompanyId(value: string | null | undefined): value is string {
  return typeof value === "string" && value.length > 0 && value.length <= 200;
}

/** Friendly company display name, never a fabricated value. */
export function companyDisplayName(name: string | null | undefined): string {
  const trimmed = (name ?? "").trim();
  return trimmed.length > 0 ? trimmed : "Unnamed company";
}

/** Neutral lifecycle label for the detail header badge. */
export function companyStatusLabel(status: string | null | undefined): string {
  if (!status) return "Active";
  return status === "active" ? "Active" : status === "archived" ? "Archived" : status;
}
